const ThankYou = ({ text }) => {
  return (
    <div className='bookingForm-container'>
      <div className='submitted'>
        <h3>{text}</h3>
      </div>
    </div>
  )
}

export default ThankYou
